import React from 'react';
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core';

const useStyles = ({
  labelHeight: {
    height: 24
  },
  statusIcon: {
    height: 17,
    width: 17,
    margin: 3
  }
});

const evaluateStyle = (input = "") => {
  switch (input) {
    case "Rozłączony+":
      return { color: "red" };
    case "Rozłączony":
      return { color: "orange" };
    case "Podłączony":
      return { color: "green" };
    default:
      return { color: "gray" };
  }
};

const convertStatusToMessage = status => {
  switch (status) {
    case "Rozłączony+":
      return "OFFLINE +24h";
    case "Rozłączony":
      return "OFFLINE";
    case "Podłączony":
      return "ONLINE";
    default:
      return "BRAK DANYCH";
  }
};

const CarStatus = (props) => {
  const { status } = props;

  return (
    <React.Fragment>
      <span className={'labelHeight'} style={evaluateStyle(status)}>
        {convertStatusToMessage(status)}
      </span>
    </React.Fragment>
  );
};

export default withStyles(useStyles)(CarStatus);

CarStatus.propTypes = {
  status: PropTypes.string
};
